import { css, styled } from 'styled-components';

import type { ScArrowProps } from '@/components/NativeSlider/helpers';

import { device } from '@/styles/helpers';

export const ScOutsideArrowsContainer = styled.div<{
  visibleArrowsForMobile?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  gap: 16px;

  & > div {
    display: flex;
    gap: 8px;
    flex-shrink: 0;

    & > a,
    & > button {
      flex-shrink: 0;
    }

    ${({ visibleArrowsForMobile }) =>
      visibleArrowsForMobile &&
      css`
        @media (${device.mobile}) {
          align-items: flex-end;
          padding-bottom: 24px;
        }
      `}
  }
`;

export const ScOutsideArrows = styled.div<{ dark?: boolean }>`
  height: 32px;
  padding: 4px 8px;
  background: ${({ theme, dark }) =>
    dark ? theme.blackColor : theme.grayLightColor};
  border-radius: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  .divider {
    height: 20px;
    width: 1px;
    background-color: ${({ theme }) => theme.whiteColor};
    opacity: 0.1;
  }
`;

const ScArrowOutside = styled.button<ScArrowProps>`
  display: block;
  border: none;
  background: none;
  z-index: 2;
  width: 100%;
  height: 100%;
  transition: all 0.3s ease 0s;
  opacity: 1;
  position: absolute;
`;

export const ScLeftArrowOutside = styled(ScArrowOutside)`
  position: relative;
  width: 24px;
  height: 24px;
  transition: 0.3s;
  transform: rotate(-180deg);

  cursor: ${({ isActive }) => (isActive ? 'pointer' : 'default')};
  opacity: ${({ isActive }) => (isActive ? 1 : 0.1)};

  ${({ isActive }) =>
    isActive &&
    css`
      @media (hover: hover) {
        &:hover {
          &:before {
            transform: rotate(-65deg);
            top: 16px;
          }
          &:after {
            transform: rotate(65deg);
            bottom: 16px;
          }
        }
      }
    `}

  &:before {
    content: '';
    display: block;
    width: 10px;
    height: 1px;
    background-color: ${({ theme }) => theme.whiteColor};
    position: absolute;
    top: 15px;
    left: 7px;
    transform: rotate(-50deg);
    transition: all 0.3s ease 0s;
  }
  &:after {
    content: '';
    display: block;
    width: 10px;
    height: 1px;
    background-color: ${({ theme }) => theme.whiteColor};
    position: absolute;
    bottom: 15px;
    left: 7px;
    transform: rotate(50deg);
    transition: all 0.3s ease 0s;
  }
`;

export const ScRightArrowOutside = styled(ScLeftArrowOutside)`
  transform: rotate(0);
`;
